module.exports = __webpack_public_path__ + "static/img/vr2.67dc7bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vr/vr2.png
// module id = tjki
// module chunks = 1